"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faTimes = require("@fortawesome/pro-regular-svg-icons/faTimes");

var _faCog = require("@fortawesome/pro-regular-svg-icons/faCog");

var _BackButton = _interopRequireDefault(require("../BackButton"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Title = _styledComponents["default"].h2(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-size: 1rem;\n    margin: 0;\n    color: #fff;\n    display: flex;\n    align-items: center;\n\n    a {\n        width: 30px;\n        cursor: pointer;\n\n        &.back {\n            color: #c0c0c0;\n        }\n    }\n\n    .faded {\n        opacity: 0.4;\n    }\n"])));

var PageTitle = function PageTitle(_ref) {
  var title = _ref.title,
      showSettings = _ref.showSettings,
      setShowSettings = _ref.setShowSettings,
      contentType = _ref.contentType;
  return /*#__PURE__*/_react["default"].createElement(Title, null, /*#__PURE__*/_react["default"].createElement(_BackButton["default"], {
    contentType: contentType
  }), /*#__PURE__*/_react["default"].createElement("a", {
    role: "button",
    onClick: function onClick() {
      return setShowSettings(!showSettings);
    },
    "data-testid": "content-toggle-settings"
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: showSettings ? _faTimes.faTimes : _faCog.faCog
  })), title.length > 0 ? /*#__PURE__*/_react["default"].createElement("span", null, title) : /*#__PURE__*/_react["default"].createElement("span", {
    className: "faded"
  }, "(Untitled Page)"));
};

var _default = PageTitle;
exports["default"] = _default;